import React from 'react';
import WhoAmI from 'components/WhoAmI';

export default {
    run: ({ print, exit }) => {
        print(<WhoAmI />);
        exit();
    },
};
